export default __webpack_public_path__ + "static/media/mariaFilo_desk_banner_3.0efdf1db.jpg";